import {
	Button, Divider, Form, Radio, Space,
} from 'antd';
import React, { useCallback, useMemo, useState } from 'react';

import './attempt-mcq.scoped.css';
import { shuffleArray } from '../../libs/utils';
import { useSessionStore } from '../../store';

interface MCQFormValues {
	answer: number
}

interface AttemptMCQProps {
	questionData: AttemptQuestionData
	submitting: boolean
	onSubmit: (data: any) => Promise<void>
	setAttempt: (attemptData: unknown) => void
	getAttempt: () => any | null
	quizData: QuizData | null
}

export const AttemptMCQ: React.FunctionComponent<AttemptMCQProps> = (props) => {
	const {
		questionData, submitting: isSubmitting, onSubmit, quizData,
	} = props;

	const sessionData = useSessionStore((state) => state.sessionData);

	const shuffledOptions = useMemo(() => {
		if (!quizData?.toShuffleMCQOptions) {
			return questionData.questionTypeMCQ?.options?.map((option, index) => ({
				label: option,
				value: index + 1,
			})) ?? [];
		}
		const options = questionData.questionTypeMCQ?.options?.map((option, index) => ({
			label: option,
			value: index + 1,
		})) ?? [];
		return shuffleArray(options, sessionData?.userId ?? '', questionData._id, quizData?.quizId);
	}, [
		quizData?.toShuffleMCQOptions, quizData?.quizId,
		questionData.questionTypeMCQ?.options, questionData._id,
		sessionData?.userId,
	]);

	const [form] = Form.useForm();

	const [answerError, setAnswerError] = useState<string | undefined>();

	const handleMCQFormSubmit = useCallback(async (values: MCQFormValues) => {
		await onSubmit({
			inputMCQ: `chkOpt${values.answer}`,
			chk: `chkOpt${values.answer}`,
		});
	}, [onSubmit]);

	const handleMCQFormSubmitFailed = useCallback(async ({ values, errorFields, outOfDate }) => {
		if (errorFields[0].errors[0]) {
			setAnswerError(errorFields[0].errors[0]);
		}
	}, []);

	return (
		<div className="attempt-mcq-container">
			<div>
				<span className="info-text">Choose any one</span>
				<Divider style={{ margin: '0.5rem 0 1.5rem 0', width: '50%', minWidth: 'unset' }} />
				<div>
					<Form
						form={form}
						onFinish={handleMCQFormSubmit}
						onFinishFailed={handleMCQFormSubmitFailed}
						onFieldsChange={() => setAnswerError(undefined)}
					>
						<Form.Item
							name="answer"
							rules={[{ required: true, message: 'Please select an option!' }]}
							initialValue={(
								typeof questionData.questionTypeMCQ?.lastSubmitted === 'number'
									? questionData.questionTypeMCQ.lastSubmitted + 1
									: (questionData.questionTypeMCQ?.lastSubmitted
										&& parseInt(questionData.questionTypeMCQ?.lastSubmitted, 10))
							)}
						>
							<Radio.Group
								disabled={isSubmitting}
							>
								<Space direction="vertical">
									{
										shuffledOptions.map((option) => (
											<Radio
												key={option.label}
												value={option.value}
											>
												{option.label}
											</Radio>
										))
									}
								</Space>
							</Radio.Group>
						</Form.Item>
						<Form.Item>
							<Button
								type="text"
								size="small"
								onClick={() => form.setFieldsValue({
									answer: null,
								})}
								disabled={isSubmitting}
							>
								Clear selection
							</Button>
						</Form.Item>
					</Form>
				</div>
			</div>
			<div className="submit-mcq-container">
				<span className="error-message">{answerError}</span>
				<Button
					type="primary"
					size="large"
					onClick={() => form.submit()}
					loading={isSubmitting}
				>
					submit
				</Button>
			</div>
		</div>
	);
};
